// The daily mood read. Twelve custom hand-drawn SVG faces (see MoodFace),
// gently animated and never dimmed. Klair sees the mood on a check in too.
// Each mood carries a colour and a 1..5 score so the week-by-week strip
// shares one source of truth (see moods.js). Moods never affect any
// assessment score.
import MoodFace from "./MoodFace";
import { MOODS, MOOD_BY_KEY, DOWN_MOODS } from "./moods";
import "./moods.css";

// Re-exported so existing imports from "./MoodPicker" keep working.
export { MOODS, MOOD_BY_KEY, DOWN_MOODS };

export function MoodPicker({ value, onChange, testid = "mood-picker", showEcho = false }) {
  const active = value ? MOOD_BY_KEY[value] : null;
  return (
    <div data-testid={testid}>
      <div className="mf-grid">
        {MOODS.map((m) => {
          const on = value === m.key;
          return (
            <button
              key={m.key}
              type="button"
              onClick={() => onChange(on ? null : m.key)}
              aria-pressed={on}
              title={m.label}
              className={`mf-tile ${on ? "is-selected" : ""}`}
              style={{ "--deep": m.c2, "--sh": `${m.c2}33`, "--gl": `${m.c2}3D` }}
              data-testid={`${testid}-${m.key}`}
            >
              <MoodFace moodKey={m.key} size={40} animate />
              <span className="mf-tile-label">{m.label}</span>
            </button>
          );
        })}
      </div>
      {showEcho && (
        <div className="mf-echo" style={{ marginTop: 10 }} data-testid={`${testid}-echo`}>
          {active ? active.echo : ""}
        </div>
      )}
    </div>
  );
}

export function MoodTag({ mood }) {
  const m = MOOD_BY_KEY[mood];
  if (!m) return null;
  return (
    <span className="k-quiet !text-xs inline-flex items-center gap-1.5" data-testid="mood-tag">
      <MoodFace moodKey={mood} size={16} animate={false} /> {m.label}
    </span>
  );
}
